// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DSATab from './DSATab';
import { isPartnerUser } from '../utils/assessmentUtils';
// css
import '../styles/components/DSATabs.scss';


const ANALYSIS_SUB_LINKS = [
  {
    name: 'engagement',
    title: 'Engagement',
    active: true
  },
  {
    name: 'data-sources',
    title: 'Data Sources',
    active: true,
    isHidden: props => !props.abilities.canViewDataSourcesAnalysis
  },
  {
    name: 'data-sources-by-area',
    title: 'Overview',
    active: true,
    isHidden: props => !props.abilities.canViewDataSourcesAnalysis
  },
  {
    name: 'overview',
    title: 'Overview',
    active: true,
    isHidden: props => props.abilities.canViewDataSourcesAnalysis
  },
  {
    name: 'security-overview',
    title: 'Security Recommendations',
    active: true,
    isHidden: props => {
      const securityArea = props.areas.find(area => area.title === 'Security, Compliance and Fraud');
      const securityExtension = props.dsa.dsaExtensions[0];
      return (
        !props.abilities.canViewSecurityAnalysis ||
        (!securityArea.active || !(securityExtension && securityExtension.active))
      );
    }
  },
  {
    name: 'overlap/:areaId',
    title: 'Overlap Analysis',
    active: true,
    isHidden: props => !props.abilities.canViewOverlapAnalysis
  }
];


class DSATabs extends Component {

  getAreaSubLinks() {
    let areas = this.props.areas || [];

    return areas.map(area => (
      {
        id: area.id,
        name: area.id,
        title: area.title,
        active: (this.props.dsa.dsaAreas.find(dsaArea => area.id === dsaArea.area) || {}).active,
        extensions: this.props.dsa.dsaExtensions
          .filter(dsaExtension => dsaExtension.extension.area === area.id)
          .filter(dsaExtension => dsaExtension.active)
          .map((ext) => {
            return this.props.configExtensions.find((x) => {
              return x.area === area.id && x.id === ext.extension.id;
            });
          })
          .filter((ext) => !!ext)
          .map((ext) => {
            return {name: `correlations/${ext.id}`, title: ext.title};
          })
      }
    ));
  }

  getFirstActiveAreaId() {
    return this.props.dsa.dsaAreas.find(a => a.active).area;
  }

  getAnalysisSubLinks() {
    return ANALYSIS_SUB_LINKS
      .filter(link => link.isHidden ? !link.isHidden(this.props) : true)
      .map(link => (
        Object.assign({}, link, {
          title: typeof(link.title) === 'function' ? link.title(this.props) : link.title,
          name: link.name.replace(':areaId', this.getFirstActiveAreaId())
        })
      ));
  }

  render() {
    const { pathname, account, baseNavRoute, user, dsa } = this.props;
    const areaSubLinks = this.getAreaSubLinks();
    const analysisSubLinks = this.getAnalysisSubLinks();
    const links = [
      {
        name: 'sources',
        title: 'Sources',
        subLinks: areaSubLinks,
        visible: true
      },
      {
        name: 'analytics',
        title: 'Analytics',
        subLinks: analysisSubLinks,
        visible: true
      }
    ];

    const visibleLinks = links.filter(link => link.visible);
    let linkToAssessmentList = (
      <a href={`/account-details/${account.sfid}`} title='Account View'>Account View</a>
    );

    if (isPartnerUser(user)) {
      let opportunityPath;
      if (dsa.opportunities && dsa.opportunities.length > 0) {
        opportunityPath = `/opportunity/${dsa.opportunities[0].sfid}/detail`;
      } else {
        opportunityPath = '/opportunity/';
      }
      linkToAssessmentList = (
        <a href={opportunityPath}>Opportunity View</a>
      );
    }

    // Tab
    return (
      <div className='dsa-tabs'>
        <div className='container'>
          <ul className='nav nav-tabs nav-justified'>
            <li>{linkToAssessmentList}</li>
            {visibleLinks.map((link, index) => (
              <DSATab
                baseNavRoute={baseNavRoute}
                key={index}
                pathname={pathname}
                {...link}
              />
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

DSATabs.propTypes = {
  pathname: PropTypes.string,
  account: PropTypes.object,
  dsa: PropTypes.object,
  areas: PropTypes.array,
  extensions: PropTypes.array,
  configExtensions: PropTypes.array,
  abilities: PropTypes.object.isRequired,
  baseNavRoute: PropTypes.string.isRequired,
  user: PropTypes.object
};

export default DSATabs;



// WEBPACK FOOTER //
// ./src/components/DSATabs.js